import React, { useState, useEffect } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import "./MobileSortModal.css";

const MobileSortModal = ({
    isOpen,
    onClose,
    onApply,
    currentColumn,
    currentOrder,
    columns = [],
}) => {
    const [column, setColumn] = useState("");
    const [order, setOrder] = useState("asc");

    useEffect(() => {
        if (currentColumn) setColumn(currentColumn);
        if (currentOrder) setOrder(currentOrder);
    }, [currentColumn, currentOrder]);

    if (!isOpen) return null;

    const handleSelect = (selectedColumn) => {
        if (column === selectedColumn) {
            setOrder((prev) => (prev === "asc" ? "desc" : "asc"));
        } else {
            setColumn(selectedColumn);
            setOrder("asc");
        }
    };

    const handleApply = () => {
        onApply(column, order);
        onClose();
    };

    return (
        <div className="mobile-sort-overlay" onClick={onClose}>
            <div
                className="mobile-sort-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <h3 className="mobile-sort-title">Sort by</h3>

                {columns.map((item) => (
                    <div
                        key={item.value}
                        className={`mobile-sort-option ${
                            column === item.value ? "mobile-sort-active" : ""
                        }`}
                        onClick={() => handleSelect(item.value)}
                    >
                        <input
                            type="radio"
                            checked={column === item.value}
                            readOnly
                            className="mobile-sort-radio"
                        />

                        <span className="mobile-sort-label">{item.label}</span>

                        {column === item.value && (
                            <span className="mobile-sort-order">
                                {order === "asc"
                                    ? "Ascending ↑"
                                    : "Descending ↓"}
                            </span>
                        )}
                    </div>
                ))}

                <div className="mobile-sort-footer">
                    <button className="mobile-sort-cancel" onClick={onClose}>
                        <FaTimes />
                    </button>

                    <button className="mobile-sort-apply" onClick={handleApply}>
                        <FaCheck />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MobileSortModal;
